import { render, staticRenderFns } from "./NewDocument.vue?vue&type=template&id=5a7ff2fc&scoped=true"
import script from "./NewDocument.vue?vue&type=script&lang=js"
export * from "./NewDocument.vue?vue&type=script&lang=js"
import style0 from "./NewDocument.vue?vue&type=style&index=0&id=5a7ff2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ff2fc",
  null
  
)

export default component.exports